import cx from 'classnames';
import {useCallback, useMemo, useRef} from 'react';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';

import './NumberField.sass';

export const NumberField = ({
  schema,
  value,
  index,
  onChange,
  errors,
  disabled,
  min = 0,
  max = schema.max || 200,
  className,
  'data-qa-id': dataQaId,
  pristine = false,
  isDesktop = false,
}) => {
  const prevValue = useRef(value);
  const id = useMemo(() => `select-box-${Date.now()}`, []);

  const onInputChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      onChange(newValue ? parseInt(newValue, 10) : newValue, false);
    },
    [onChange]
  );

  const onInputBlur = useCallback(
    (e) => {
      const newValueStr = e.target.value;
      if (!newValueStr) {
        prevValue.current = null;
        return;
      }
      let newValue = parseInt(newValueStr, 10);
      if (newValue < min) newValue = min;
      else if (newValue > max) newValue = max;
      onChange(newValue, newValue !== prevValue.current);
      prevValue.current = newValue;
    },
    [onChange, min, max]
  );

  return (
    <div className="number-field__wrapper">
      <Input
        type="number"
        counter
        id={id}
        className={cx(`${schema.name}-wrapper`, {
          [className]: !!className,
        })}
        min={min}
        max={max}
        value={value}
        onChange={onInputChange}
        onBlur={onInputBlur}
        index={index}
        error={errors?.[0]?.msg}
        disabled={disabled}
        data-qa-id={`${dataQaId}-value`}
        data-qa-value={value}
        live
        variant={isDesktop ? 'paragraph1' : 'paragraph2'}
        hideCounterArrows
        pristine={pristine}
      />
      <Typography
        color="pebble"
        variant={isDesktop ? 'paragraph1' : 'paragraph2'}
        className="number-field__signups-text"
      >
        signups
      </Typography>
    </div>
  );
};
